<template>
  <div class="form-check"
       :class="[{disabled: disabled}, inlineClass]">
    <label :for="cbId" class="form-check-label">
      <slot>
        <span v-if="inline">&nbsp;</span>
      </slot>
      <input :id="cbId"
             class="form-check-input"
             type="checkbox"
             :disabled="disabled"
             v-model="model"/>
      <span class="form-check-sign"></span>
    </label>
  </div>
</template>
<script>
export default {
  name: 'n-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean, String],
    disabled: Boolean,
    inline: Boolean,
    hasError: Boolean
  },
  data() {
    return {
      cbId: '',
      touched: false
    };
  },
  computed: {
    model: {
      get() {
        return this.checked;
      },
      set(check) {
        if (!this.touched) {
          this.touched = true;
        }
        this.$emit('input', check);
      }
    },
    inlineClass() {
      if (this.inline) {
        return `form-check-inline`;
      } else {
        return true
      }
    }
  },
  created() {
    this.cbId = Math.random()
      .toString(16)
      .slice(2);
  }
};
</script>
<style>
.form-check .form-check-sign::before, .form-check .form-check-sign::after {
  width: 16px;
  height: 16px;
}

.form-check .form-check-label {
  padding-left: 25px;
  line-height: 15px;
}

.form-check-input{
  height: 16px;
  width: 16px;
  margin-top: 0;

}
.label-check {

}
.card label {
  font-size: 0.8571em;
  margin-bottom: 5px;
  color: #9A9A9A;
}
</style>
